export default "__VITE_ASSET__b8980946__"